const publicbackendurl = process.env.REACT_APP_NEXUS_API_PUBLIC
const protectedbackendurl=process.env.REACT_APP_NEXUS_API_PROTECTED
const devEnv = process.env.REACT_APP_IS_DEV 

const jwt = process.env.REACT_APP_JWT


export const get_dept = async()=>{
    const url = `${publicbackendurl}/get-depts`
    const response = (await fetch(url)).json()
    console.log('Response ',response)
    return response
}
/*
export const user_profile = async()=>{
    const url = `${protectedbackendurl}/user-profile`
    const response = (await fetch(url)).json()
    return response
}*/

export const user_profile = async () => {
    //console.log('API URL ',`${protectedbackendurl}/user-profile`);
    const url = `${protectedbackendurl}/user-profile`;
    console.log('API URL ',`${protectedbackendurl}/user-profile`,url);
    // Retrieve accessToken from localStorage
   // const accessToken = localStorage.getItem('accessToken');

    // Define headers
    const headers = {
        'Content-Type': 'application/json', // Ensure proper content type
     };

    try {
        const response = await fetch(url, {
            method: 'GET', // Default is GET, explicitly stating it
            headers: headers,
		credentials:'include'
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
	const data = await response.json();
	//console.log('Data for User Profile ',data)
        return data; // Await JSON parsing
    } catch (error) {
        console.error('Error fetching user profile:', error);
        return null; // Handle errors gracefully
    }
};


export const reg_user = async(email,selectedDepartment)=>{
    const data = {
        userEmail: email,
        department: selectedDepartment
    }
    const url = `${publicbackendurl}/register`
    const response = (await fetch(url,{
        method:'POST',
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify(data),
    }))
    const responseData = await response.json();
    console.log(responseData)
    return responseData
}

export const update_user = async (firstName, lastName, departmentname, occupation, contactNo, emailid) => {
    const data = {
        firstName: firstName,
        lastName: lastName,
        department: departmentname,   // Adjust this to match the schema
        occupation: occupation,
        contactnumber:Number(contactNo), // Adjust this to match the schema
        NDSU_EmailId: emailid   
    };
    console.log('Request Data:', data);
    const url = `${protectedbackendurl}/user-profile/`;
    
    try {
        const response = await fetch(url, {
            method: 'PUT',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const responseData = await response.json();
        console.log('Update response:', responseData); // Log the entire response for debugging

        // Return the whole response
        return responseData; 
    } catch (error) {
        console.error("Error in update_user:", error);
        // Handle or re-throw the error as needed
        throw error; // This will be caught by the calling function
    }
};



// export const update_user = async () => {
//     const staticData = {
//         firstName: "John",
//         lastName: "Doe",
//         // departmentName: "Engineering", // Ensure this matches your API's expected field name
//         occupation: "Software Engineer",
//         contactNo: 1234567890,  // Use a valid number
//         // emailid: "john.doe@example.com"
//     };
//     console.log('Static Request Data:', staticData);
//     const url = `${backendurl}/user-profile/`;
    
//     try {
//         const response = await fetch(url, {
//             method: 'PUT',
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify(staticData),
//         });

//         const responseData = await response.json();
//         console.log('Update response:', responseData); // Log the entire response for debugging

//         if (!response.ok) {
//             throw new Error(`HTTP error! Status: ${response.status} - ${responseData.message}`);
//         }

//         return responseData; // Return the whole response or adjust based on structure
//     } catch (error) {
//         console.error("Error in update_user:", error);
//         throw error; // This will be caught by the calling function
//     }
// };





export const get_verified = async(email,verificationCode)=>{
    const body={
        userEmail:email,
        verificationCode:parseInt(verificationCode)
    }
    const url=`${publicbackendurl}/verify`
    const response = await fetch(url,{
        method:'POST',
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify(body),
    })
    const data = await response.json()
    return data
    
}
export const get_apps = async() => {
    const url = `${publicbackendurl}/get-apps`;
    //const token = getCookie();
    try {
        if(parseInt(devEnv)===0){
            const response = await fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: { "Content-Type": "application/json"}, // Corrected "applications/json" to "application/json"
            });
            
            const jsonData = await response.json();
            console.log(jsonData)
            return jsonData;
        }
        else{
            const response = await fetch(url, {
                method: 'GET',
            });
            const jsonData = await response.json();
            return jsonData;   
        }
        
        
    } catch (err) {
        return err;
    }
};






export const get_login = async (ticket) => {
    const data = {ticket}
    const url = `${publicbackendurl}/grant-access`;    
    try {
        const response = await fetch(url,{
            method: 'POST',
            headers: { "Content-Type": "application/json"}, 
            body: JSON.stringify(data),
        })
        const responsedata= await response.json();
        return responsedata    
    } catch (error) {
        return null; // Handle the error appropriately
    }
};

// export const get_apps = async() => {
//     const url = `${backendurl}/get-apps`;
//     //const token = getCookie();
//     try {
//         if(parseInt(devEnv)===0){
//             const response = await fetch(url, {
//                 method: 'GET',
//                 credentials: 'include',
//                 headers: { "Content-Type": "application/json"}, // Corrected "applications/json" to "application/json"
//             });
//             const jsonData = await response.json();
//             return jsonData;
//         }
//         else{
//             const response = await fetch(url, {
//                 method: 'GET',
               
//                 headers: { "Content-Type": "application/json",
//                     "jwt":jwt                
//                 }, // Corrected "applications/json" to "application/json"
//             });
//             const jsonData = await response.json();
//             return jsonData;   
//         }
        
        
//     } catch (err) {
//         return err;
//     }
// };

export const get_landing_apps = async()=>{
    const url = `${publicbackendurl}/get-landing-apps`
    try{
        const response = await fetch(url,{
            method:'GET',
            headers:{"Content-Type":"application/json"},
        });
        const data = await response.json();
        return data
    }catch(err){return err}
}

export const userLogout=async()=>{
    const url = `${publicbackendurl}/user-logout`
    try{
        const response = await fetch(url,{
            method: 'POST',
            credentials: 'include',
            headers:{"Content-Type":"application/json"},
        });
        const data = await response.json();
        console.log(data)
        return data
    }catch(err){
        return err
    }
}

export const sendVerifyCodeUserReq=async(email)=>{
    //console.log(JSON.stringify(email))
    const url = `${publicbackendurl}/get-verification-code`
    const data={
        userEmail: email,
    }
    try{
        const response = await fetch(url,{
            method:'POST',
            headers:{"Content-Type":"application/json"},
            body:JSON.stringify(data),
        })
        const jsonData = await response.json();
        return jsonData
    }catch(err){
        return err
    }
}





